/**
 * D-01 (DESIGN-DECISIONS-LOG) — Default profile/gallery portrait for the 0-Wheels state.
 *
 * When a user has NO Wheels, the profile/gallery portrait frame must render a
 * GENERIC iYuga Wheel: the six brand colors in six EQUAL segments, drawn with the
 * SAME live wheel renderer (WheelComponent) used for real portraits — never a
 * bespoke placeholder image, and never a hollow center (upholds the
 * small-wheel-thumbnail-portrait law + every-wheel-design-conformant).
 *
 * Single source of truth: every 0-Wheel portrait surface (gallery profile card
 * `WheelGallery/Profile`, header avatar `ProfileMenu`, ...) consumes this so the
 * generic portrait is identical everywhere ("everything is a shared component").
 *
 * The six hues are the iYuga brand-wheel rainbow, grounded in the brand-wheel
 * mark asset (`assets/images/primaryWheelPlaceholderImage.svg`) and the canonical
 * brand avatar gradient used across the design deck (`#9B5AF8 / #F79A00 / #2DD4BF`).
 * Exact hexes are open to design fine-tuning; the LAW is "six brand colors, six
 * equal segments, real renderer, no hollow center".
 */

export const IYUGA_BRAND_WHEEL_COLORS = [
  "#9B5AF8", // brand purple (primary-500, the signature)
  "#5BD6FD", // sky blue
  "#2DD4BF", // teal
  "#F5CC3B", // yellow
  "#F79A00", // orange
  "#FF71A7", // pink
];

/**
 * Build six EQUAL generic brand segments in the exact chartData shape that
 * WheelComponent / createPie expects. Each segment has value:1 so the six wedges
 * are exactly equal (60° each). `title: ""` keeps the wheel label-free — createPie
 * only draws a label for segments whose title is a non-empty string.
 *
 * Returns a fresh array on every call so each portrait instance owns its data
 * (no cross-instance sharing of mutable render state).
 */
export const getGenericWheelSegments = () =>
  IYUGA_BRAND_WHEEL_COLORS.map((color, i) => ({
    id: `generic-seg-${i}`,
    value: 1,
    color,
    title: "",
    position: i,
    pattern: null,
    selected: false,
    isBlank: false,
  }));

/** Stable userData id for the generic portrait (avoids per-render churn). */
export const GENERIC_WHEEL_USER_ID = "generic-portrait";
